"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.algoRerunBody = exports.replaceLearnerBody = void 0;
const joi_1 = __importDefault(require("joi"));
const __1 = require("..");
const __2 = require("../..");
exports.replaceLearnerBody = (0, __2.objectSchema)({
    learnerIn: (0, __2.objectSchema)(__1.sampleEntryDef),
    learnerOut: (0, __2.objectSchema)(__1.sampleEntryDef),
    sampleId: joi_1.default.string().required(),
});
exports.algoRerunBody = (0, __2.objectSchema)({
    sampleId: joi_1.default.string().required(),
    rerunInfo: (0, __2.objectSchema)(__1.algoRerunDef),
});
